import { render } from "./EnviarFotos.vue?vue&type=template&id=1863fcf8"
import script from "./EnviarFotos.vue?vue&type=script&lang=js"
export * from "./EnviarFotos.vue?vue&type=script&lang=js"

import exportComponent from "E:\\sistemas\\sinos_web\\sinos_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__